const STORAGE_KEY = "storefront:purchase-dispatch:v1";
const pending = new Map();
const sentInMemory = new Set();
const MAX_WAIT_MS = 15000;

export const marketingUnitPrice = item => {
  const quantity = Number(item.quantity) || 0;
  return (Number(item.total_price) || 0) +
    (quantity > 0 ? (Number(item.quantityExcludedOptionsTotal) || 0) / quantity : 0);
};

const readSent = () => {
  try {
    const value = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || "[]");
    return Array.isArray(value) ? value : [];
  } catch (_) { return []; }
};

// Queueing to an SDK is not proof of provider receipt. This prevents repeated
// browser dispatch, independently for each configured integration and order.
export const dispatchPurchase = ({ platform, destination, orderId, ready, send }) => {
  if (!orderId || !platform) return;
  // Respect purchases already recorded before the per-platform ledger rollout.
  try { if (sessionStorage.getItem("lastConversionID") === orderId) return; } catch (_) {}
  const key = JSON.stringify([platform, destination || "", orderId]);
  if (sentInMemory.has(key) || readSent().includes(key) || pending.has(key)) return;
  const started = Date.now();
  pending.set(key, true);
  const attempt = () => {
    try {
      if (ready()) {
        send();
        sentInMemory.add(key);
        if (sentInMemory.size > 200) sentInMemory.delete(sentInMemory.values().next().value);
        try {
          sessionStorage.setItem(STORAGE_KEY, JSON.stringify([...readSent(), key].slice(-200)));
        } catch (_) {}
        pending.delete(key);
        return;
      }
    } catch (_) {
      // A broken tracker must not block the other platforms or checkout.
      pending.delete(key);
      return;
    }
    if (Date.now() - started >= MAX_WAIT_MS) {
      pending.delete(key);
      return;
    }
    // Success immediately navigates to tracking. Allow this bounded queue to
    // survive that navigation so late SDK loading does not lose the purchase.
    setTimeout(attempt, 100);
  };
  attempt();
};

export const getPurchaseData = (routeState, routeId, lastOrder) => {
  const canonical = id => typeof id === "string" ? id.split("-").slice(0, 2).join("-") : "";
  const order = routeState?.tracking_id ? routeState : lastOrder;
  const trackingId = canonical(order?.tracking_id);
  if (!trackingId || (routeId && canonical(routeId) !== trackingId)) return null;
  if (!Array.isArray(order?.cart) || !order.cart.length) return null;
  const value = Number(order.total_price_with_discounts);
  if (order.total_price_with_discounts == null || !Number.isFinite(value) || value < 0) return null;
  return { trackingId, value, cart: order.cart };
};
